<template>
    <div class="content-nodata flex flex-col my-auto justify-center items-center" data-cy="container_nodata">
        <div v-if="!isTextOnly">
            <img src="@/assets/image/img-nodata.svg" data-cy="img_nodata" />
        </div>
        <div class="text-14 text-a-gray-a4a4a4 pt-2" data-cy="text_nodata_message" v-html="textData"></div>
    </div>
</template>
<script>
export default {
    name: 'NoData',
    props: {
        textData: { type: String },
        isTextOnly: { type: Boolean, default: false },
    }
}
</script>
<style lang="scss" scoped>
.content-nodata{
    min-height: calc(100vh - 300px);
}
</style>
